<div
  class="performance-group-header"
  edsFlexbox
  *ngIf="performanceViewToggle.length > 1"
>
  <div
    class="performance-group-header__toggle"
    edsPadding
    edsPaddingRight="xs"
    edsPaddingTop="md"
    edsPaddingBottom="sm"
    edsFlexbox
    justifyContent="space-between"
    flexDirection="column"
  >
    <p class="small performance-group-header__toggle-label spacing--xs">
      {{ "products.show-performance" | translate }}
    </p>
    <p
      class="performance-group-header__toggle-label small text-grey1 spacing--none"
    >
      {{ performanceAsOf }}
    </p>
  </div>

  <div class="performance-group-header__toggle print-hidden">
    <div>
      <div edsSpacing="xs">
        <eds-toggle
          *ngIf="performanceViewToggle.length > 1"
          [toggleButtons]="performanceViewToggle"
          (toggleActive)="onPerformanceTypeUpdate($event)"
        ></eds-toggle>
      </div>
      <div edsSpacing="xs">
        <div>
          <eds-toggle
            [toggleButtons]="periodEndToggle"
            (toggleActive)="onPeriodEndUpdate($event)"
          ></eds-toggle>
        </div>
      </div>
    </div>
    <div
      *ngIf="showPerformanceCurrencyDropdown"
      class="performance-group-header__currency"
      edsPadding
      edsPaddingLeft="xs"
    >
      <eds-dropdown
        [id]="'performance-currency-dropdown'"
        [name]="'performance-currency-dropdown'"
        [label]="'products.ppss-performance-currency-label' | translate"
        [titleText]="'products.ppss-filter-select' | translate"
        [items]="performanceCurrencyOptions"
        [preselectedValue]="selectedPerformanceCurrencyOption"
        (dropdownChange)="onPerformanceCurrencyUpdate($event)"
        theme="ag-grid"
      >
      </eds-dropdown>
    </div>
  </div>
</div>

<div
  edsFlexbox
  *ngIf="performanceViewToggle.length === 1"
  justifyContent="space-between"
  [alignItems]="(isMobile$ | async) ? '' : 'center'"
  [flexDirection]="(isMobile$ | async) ? 'column' : ''"
>
  <div
    [style.display]="(isHandheld$ | async) ? 'none' : ''"
    *ngIf="showAnnualNav"
  >
    <p
      class="small performance-group-header__toggle-label spacing--xs"
      *ngIf="performanceViewOptions.length === 1 && isSiteIntl"
    >
      {{ performanceViewOptions[0].headerLabelKey | translate }}
    </p>
    <p
      class="small performance-group-header__toggle-label spacing--xs"
      *ngIf="performanceViewOptions.length === 1 && !isSiteIntl"
    >
      {{ selectedPerfTypeHeaderKey | translate }}
      <eds-footnote [placement]="placement"></eds-footnote>
    </p>
    <p
      class="performance-group-header__toggle-label small text-grey1 spacing--none"
    >
      {{ performanceAsOf }}
    </p>
  </div>

  <div
    edsPadding
    [edsPaddingTop]="(isMobile$ | async) ? 'md' : ''"
    class="performance-group-header__toggle performance-group-header__toggle--single print-hidden"
    *ngIf="showAnnualNav"
  >
    <div>
      <eds-toggle
        [toggleButtons]="periodEndToggle"
        (toggleActive)="onPeriodEndUpdate($event)"
      ></eds-toggle>
    </div>

    <div *ngIf="showPerformanceCurrencyDropdown" edsPadding edsPaddingTop="xs">
      <eds-dropdown
        [id]="'performance-currency-dropdown'"
        [name]="'performance-currency-dropdown'"
        [label]="'products.ppss-performance-currency-label' | translate"
        [titleText]="'products.ppss-filter-select' | translate"
        [items]="performanceCurrencyOptions"
        [preselectedValue]="selectedPerformanceCurrencyOption"
        (dropdownChange)="onPerformanceCurrencyUpdate($event)"
        theme="ag-grid"
      >
      </eds-dropdown>
    </div>
  </div>
</div>
